import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';

import { Constants } from '../model/constants';
import { Utils } from './utils/utils';
import { User } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

     constructor(private http: HttpClient) { }

    login(user: User): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'auth/login';
        return this.http.post(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            JSON.stringify(user),
            {headers}
        );
    }

    logout(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'auth/logout';
        return this.http.get(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            {headers}
        );
    }

    logged(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'auth/logged';
        return this.http.get(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            {headers}
        );
    }

}
